<template>
  <div class="modal-card" style="margin: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("vending.changeProductToWhichCategory") }}
      </p>
    </header>

    <section class="modal-card-body">
      <b-field style="margin-top: 1rem; margin-bottom: 1rem;">
        <b-field>
          <b-select :placeholder="$t('common.select')" v-model="category">
            <option value="">
              {{ $t("common.select") }}
            </option>

            <option v-for="c in eligibleCategories" :value="c._id" :key="c._id">
              {{ c.name }}
            </option>
          </b-select>

          <b-button
            class="button"
            :style="{
              backgroundColor: $primaryColor,
              color: $primaryColorContrast
            }"
            @click="changeCategory(category)"
            :disabled="!category"
          >
            {{ $t("common.confirm") }}
          </b-button>
        </b-field>
      </b-field>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  props: ["eligibleCategories", "product", "vending"],

  data() {
    return {
      isLoading: false,
      category: ""
    };
  },

  methods: {
    changeCategory(category) {
      this.isLoading = true;
      this.$store
        .dispatch("changeVendingProductCategory", {
          categoryId: category,
          barcode: this.product.b,
          vendingId: this.vending._id
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: this.$t("vending.productCategoryUpdated"),
              type: "is-success",
              position: "is-bottom",
              duration: 3000
            });
            this.$emit("update-vending");
            this.$parent.close();
          }
        })
        .catch(err => {
          this.alertError(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
